<script setup>
import { useRoute } from 'vue-router';

const props = defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
  // Quem rola: o wrapper ou a tela de dentro?
  //
  // O padrão é o wrapper — ele tem `overflow-auto` e o filho fica em `items-start`, ou seja
  // com a altura do próprio conteúdo. Funciona para tela de formulário, que é a maioria aqui.
  //
  // Não funciona para tela com painel fixo. A de agente tem um menu lateral que precisa ficar
  // parado enquanto o conteúdo rola, e ela até declara `h-full overflow-hidden` — mas `h-full`
  // não tem contra o que resolver debaixo de `items-start`, então a barra que aparecia era a
  // de fora, arrastando o menu junto. Com isto ligado, a altura chega até lá e o
  // `overflow-y-auto` de dentro passa a valer.
  fullHeight: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 bg-n-background"
    :class="
      props.fullHeight ? 'overflow-hidden' : 'pb-8 pt-4 px-6 overflow-auto'
    "
  >
    <div
      class="flex w-full"
      :class="props.fullHeight ? 'flex-1 min-h-0' : 'items-start'"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
